import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import { howItWorks } from '../../data/mock';

const HowItWorks = () => {
  return (
    <section className="py-24 bg-gradient-to-br from-[#6B2C91] via-[#5a2579] to-[#4a1f64] relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-white/5 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-[#FFD700]/10 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#FFD700] font-semibold text-sm uppercase tracking-wider">
            Comment Ça Marche
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold text-white">
            Obtenez Votre Carte en 3 Étapes
          </h2>
          <p className="mt-4 text-lg text-white/80">
            Simple, rapide, et vous êtes prêt à profiter de tous les avantages KIPAY.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {howItWorks.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector line */}
              {index < howItWorks.length - 1 && (
                <div className="hidden md:block absolute top-12 left-full w-full h-0.5 bg-white/20 -translate-x-1/2 z-0" />
              )}

              <div className="relative z-10 text-center">
                {/* Step number */}
                <div className="w-24 h-24 mx-auto mb-6 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm border border-white/20">
                  <span className="text-4xl font-bold text-[#FFD700]">{step.step}</span>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-white mb-3">
                  {step.title}
                </h3>
                <p className="text-white/70">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button
            size="lg"
            className="bg-[#FFD700] hover:bg-[#e6c200] text-gray-900 font-semibold px-8 group"
          >
            Commander Ma Carte Maintenant
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
          <p className="mt-4 text-white/60 text-sm">
            Délai de livraison : 7 jours ouvrés
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
